module.exports = __webpack_public_path__ + "img/moneyReport.ed90888a.svg";